module.exports = __webpack_public_path__ + "bb65acab57ae62d6daf2f7a95f8af80b.svg";


//////////////////
// WEBPACK FOOTER
// ./images/combined-shape.svg
// module id = 84
// module chunks = 0